export default __webpack_public_path__ + "static/media/illustration-resourceful.c2ec0f61.svg";